module.exports = __webpack_public_path__ + "media/images/escudo_noti-a27271be242b6835331d4c582817cfa2.png";